'use client';

import { c as _c } from "react/compiler-runtime";
import { Heading, Icon, Modal, ModalBody, ModalFooter, ModalHeader } from '@petsmart-ui/sparky';
import type { AccountAddressesSynced } from '@libs/common-next';
import { useRemoveAddress } from '@libs/shared-ui';
import { GenericButton } from '../GenericButton';
import { trackErrorAddress, trackRemoveAddress } from './utils';
import './RemoveAddressModal.scss';
const componentClassname = 'remove-address-modal';
type RemoveAddressModalProps = {
  syncedAddresses: AccountAddressesSynced[] | undefined;
  isActive: boolean;
  isFraudValidationNeeded?: boolean;
  closeModal: () => void;
  addressId: number | undefined;
  closeForm: () => void;
};
export function RemoveAddressModal(t0) {
  const $ = _c(55);
  const {
    syncedAddresses,
    isActive,
    closeModal,
    addressId,
    isFraudValidationNeeded: t1,
    closeForm
  } = t0;
  const isFraudValidationNeeded = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== syncedAddresses) {
    t2 = syncedAddresses?.find(_temp);
    $[0] = syncedAddresses;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const defaultAddress = t2;
  let t3;
  if ($[2] !== addressId || $[3] !== syncedAddresses) {
    t3 = syncedAddresses?.find(a_0 => a_0.addressId === addressId);
    $[2] = addressId;
    $[3] = syncedAddresses;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const selectedAddress = t3;
  const t4 = selectedAddress ?? undefined;
  let t5;
  if ($[5] !== closeForm || $[6] !== closeModal) {
    t5 = {
      close: closeForm,
      back: closeModal,
      navigate: _temp2
    };
    $[5] = closeForm;
    $[6] = closeModal;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== closeForm) {
    t6 = () => Promise.resolve(closeForm());
    $[8] = closeForm;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== closeModal || $[11] !== defaultAddress || $[12] !== isFraudValidationNeeded || $[13] !== syncedAddresses || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = {
      defaultAddress,
      addresses: syncedAddresses,
      order: undefined,
      addressToRemove: t4,
      isFraudValidationNeeded,
      handleDrawerNavigation: t5,
      hasSuccessHandler: true,
      onUpdate: t6,
      handleBack: closeModal,
      onRemoveAddressSuccess: trackRemoveAddress,
      onRemoveAddressError: _temp3
    };
    $[10] = closeModal;
    $[11] = defaultAddress;
    $[12] = isFraudValidationNeeded;
    $[13] = syncedAddresses;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const {
    currentStep,
    isLoading,
    REMOVE_STEP,
    handleRemoveAddress,
    setCurrentStep
  } = useRemoveAddress(t7);
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Heading tagName="h5" className={`${componentClassname}__heading`}>Remove address</Heading>;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== closeModal) {
    t9 = () => {
      closeModal();
    };
    $[19] = closeModal;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Icon name="x" />;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t9) {
    t11 = <ModalHeader data-testid="modal-header" closeButtonText="close">{t8}<button className="sparky-c-button sparky-c-modal__close-button sparky-c-button--bare sparky-c-button--circle" aria-pressed="true" type="button" onClick={t9} data-testid="modal-close-btn">{t10}</button></ModalHeader>;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== REMOVE_STEP || $[25] !== currentStep) {
    t12 = !!REMOVE_STEP[currentStep].title && <p className={`${componentClassname}__non-removable--subtitle`}>{REMOVE_STEP[currentStep].title}</p>;
    $[24] = REMOVE_STEP;
    $[25] = currentStep;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = currentStep === "linkedConfirmation" && isFraudValidationNeeded ? "This will remove the address from your account. Your Autoship orders will continue using this address." : REMOVE_STEP[currentStep].description;
  let t14;
  if ($[27] !== t13) {
    t14 = <p>{t13}</p>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t14) {
    t15 = <ModalBody data-testid="modal-body" className={`${componentClassname}__body`}><div className={`${componentClassname}__non-removable--text`}>{t12}{t14}</div></ModalBody>;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== REMOVE_STEP || $[33] !== closeModal || $[34] !== currentStep || $[35] !== isFraudValidationNeeded || $[36] !== setCurrentStep) {
    t16 = !!REMOVE_STEP[currentStep].cancelButton && <GenericButton className={`${componentClassname}__keep-cta`} size="lg" text={isFraudValidationNeeded ? "Cancel" : "Keep address"} onClick={() => {
      closeModal();
      setCurrentStep("initialStep");
    }} />;
    $[32] = REMOVE_STEP;
    $[33] = closeModal;
    $[34] = currentStep;
    $[35] = isFraudValidationNeeded;
    $[36] = setCurrentStep;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== currentStep || $[39] !== handleRemoveAddress) {
    t17 = async () => {
      await handleRemoveAddress(currentStep);
    };
    $[38] = currentStep;
    $[39] = handleRemoveAddress;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  const t18 = currentStep === "linkedConfirmation" ? `${componentClassname}__remove-cta` : "";
  const t19 = REMOVE_STEP[currentStep];
  let t20;
  if ($[41] !== isLoading || $[42] !== t17 || $[43] !== t18 || $[44] !== t19.modalActionButtonText) {
    t20 = <GenericButton data-testid="remove-address-cta" loading={isLoading} disabled={isLoading} onClick={t17} className={t18} variant="primary" size="lg" text={t19.modalActionButtonText} />;
    $[41] = isLoading;
    $[42] = t17;
    $[43] = t18;
    $[44] = t19.modalActionButtonText;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t16 || $[47] !== t20) {
    t21 = <ModalFooter data-testid="modal-footer" className={`${componentClassname}__footer`} alignEnd={true}>{t16}{t20}</ModalFooter>;
    $[46] = t16;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== closeModal || $[50] !== isActive || $[51] !== t11 || $[52] !== t15 || $[53] !== t21) {
    t22 = <Modal dismissible={true} isActive={isActive} className={componentClassname} onClose={closeModal}>{t11}{t15}{t21}</Modal>;
    $[49] = closeModal;
    $[50] = isActive;
    $[51] = t11;
    $[52] = t15;
    $[53] = t21;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  return t22;
}
function _temp3(errorMessage) {
  return trackErrorAddress(errorMessage);
}
function _temp2() {}
function _temp(a) {
  return a.isPrimary;
}